import { autoinject } from "aurelia-dependency-injection";
import { ConfigService } from "./config.service";
import { HtmlHelper } from "../../helpers/html.helper";
import { NumberHelper } from "../../helpers/number.helper";
import { GuidHelper } from "../../helpers/guid.helper";
import { SearchHelper } from "../../helpers/search.helper";
import { EntityTypes } from "../../models/basic.models";
import type { EntityTypeConfigurationModel } from "../../components/comp-entity-finder/comp-entity-finder.models";
import * as moment from "moment";

@autoinject
export class EntityTypeConfigrationService {

    public baseUrl: string;

    constructor (configService: ConfigService) { 
        this.baseUrl = configService.config.urls.rightShipPlatformUrl.replace(window.location.origin, '');
    }

    getAllConfigs() {
        const allEntityTypeConfigurationConstants: EntityTypeConfigurationModel[] = [
            {
                title: "Vessels",
                uri: "AllVesselSearch",
                key: 'AllVesselSearch',
                typeSingular: "Vessel",
                isVisible: true,
                properties: "name",
                format: (filter, item) => {
        
                    let html = "<div class='comp-entity-finder--vessel-item column'><p class='name'>" + item.name + "</p>"
        
                    html += "<div class='prop-container row'>";
                    if (item.internationalMaritimeOrganizationNumber){
                        html += `<span class='prop'>IMO ${HtmlHelper.syntaxHighlight(filter, item.internationalMaritimeOrganizationNumber)}</span>&nbsp;`;
                    }
        
                    if (item.vehicleIdentificationNumber){
                        html += `<span class='prop'>VIN ${HtmlHelper.syntaxHighlight(filter, item.vehicleIdentificationNumber)}</span>&nbsp;`;
                    }
        
                    if (item.europeanNumberOfIdentification){
                        html += `<span class='prop'>ENI ${HtmlHelper.syntaxHighlight(filter, item.europeanNumberOfIdentification)}</span>&nbsp;`;
                    }
        
                    if (item.maritimeMobileServiceIdentityNumber){
                        html += `<span class='prop'>MMSI ${HtmlHelper.syntaxHighlight(filter, item.maritimeMobileServiceIdentityNumber)}</span>&nbsp;`;
                    }
        
                    if (item.deadweightTonnage){
                        html += `<span class='prop'>DWT ${NumberHelper.getFormattedValue(item.deadweightTonnage, null, 0, 0)}</span>&nbsp;`;
                    }
        
                    if (item.vesselTypeValue)
                        html += `<span class='prop'>${item.vesselTypeValue}</span>`;
        
                    html += "</div>";
                    html += "</div>";
        
                    return html;
                },
                claims: []
            },
            {
                title: "Vessels",
                uri: "VesselSearch",
                key: 'InformativeVesselSearch',
                typeSingular: "Vessel",
                isVisible: true,
                editRoute: "vessel-details",
                properties: "name",
                format: (filter, item, isAuthenticated, isFilter) => {
        
                    const trackingGuid = GuidHelper.generateGuid();
        
                    if (isFilter && !isAuthenticated) {
                        let html = isAuthenticated ? "<a class='column' href='" + this.baseUrl + "/vessel/" + item.id + "?entity-search=" + trackingGuid + "'>" : "<div class='column'>";
        
                        html += "<div class='row nowrap'>";
        
                        html += "<svg class='icon-arrow' version='1.1' viewBox='0 0 14 14'>" +
                            "<path d='M13,0h0.2h0.1l0,0h0.1h0.1h0.1l0,0l0.2,0.2l0.1,0.1l-0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2l0,0c0,0,0,0.1,0,0.1l0,0" +
                            "v0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1l0,0c0.1,0,0.2,0.1,0.2,0.2l0,0c0,0.1,0,0.1,0,0.2v9c0,0.6-0.4,1-1,1s-1-0.4-1-1l0,0V3.4L1.7,13.7" +
                            "c-0.4,0.4-0.9,0.4-1.3,0.1l-0.1-0.1c-0.4-0.4-0.4-1,0-1.4c0,0,0,0,0,0l0,0L10.6,2H4C3.5,2,3.1,1.6,3,1.1V1c0-0.6,0.4-1,1-1H13z'/>" +
                            "</svg>";
        
                        html += `<span class='name'>${HtmlHelper.syntaxHighlight(filter, item.name)}</span>`;
        
                        if (item.internationalMaritimeOrganizationNumber)
                            html += `, <span class='prop'>${HtmlHelper.syntaxHighlight(filter, item.internationalMaritimeOrganizationNumber)}</span>`;
        
                        html += isAuthenticated ? "</a>" : "</div>";
        
                        return html;
                    } else {
                        if (item.unfitForQuickSearch){
                            if (!SearchHelper.isSearchVesselIMO(item, filter)) {
                                return "";
                            }
                        }
                        
                        let html = isAuthenticated ? "<a class='column' href='" + this.baseUrl + "/vessel/" + item.id + "?entity-search="+trackingGuid+"'>" : "<div class='column'>";
        
                        html += "<div class='row nowrap'>";
        
                        html += "<svg class='icon-arrow' version='1.1' viewBox='0 0 14 14'>" +
                            "<path d='M13,0h0.2h0.1l0,0h0.1h0.1h0.1l0,0l0.2,0.2l0.1,0.1l-0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2l0,0c0,0,0,0.1,0,0.1l0,0" +
                            "v0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1l0,0c0.1,0,0.2,0.1,0.2,0.2l0,0c0,0.1,0,0.1,0,0.2v9c0,0.6-0.4,1-1,1s-1-0.4-1-1l0,0V3.4L1.7,13.7" +
                            "c-0.4,0.4-0.9,0.4-1.3,0.1l-0.1-0.1c-0.4-0.4-0.4-1,0-1.4c0,0,0,0,0,0l0,0L10.6,2H4C3.5,2,3.1,1.6,3,1.1V1c0-0.6,0.4-1,1-1H13z'/>" +
                            "</svg>";
        
                        html += `<span class='name'>${HtmlHelper.syntaxHighlight(filter, item.name)}</span>`;
        
                        if (item.previousName)
                            html += `<span class='previous-name'>(${HtmlHelper.syntaxHighlight(filter, item.previousName)})</span>`;
                        html += "</div>";
        
                        html += "<div class='prop-container row'>";
        
                        if (item.internationalMaritimeOrganizationNumber) {
                            html += `<span class='prop'>IMO ${HtmlHelper.syntaxHighlight(filter, item.internationalMaritimeOrganizationNumber)}</span>`;
                        }
                        else if (item.vehicleIdentificationNumber) {
                            html += `<span class='prop'>VIN ${HtmlHelper.syntaxHighlight(filter, item.vehicleIdentificationNumber)}</span>`;
                        }
                        else if (item.europeanNumberOfIdentification) {
                            html += `<span class='prop'>ENI ${HtmlHelper.syntaxHighlight(filter, item.europeanNumberOfIdentification)}</span>`;
                        }
                        else if (item.maritimeMobileServiceIdentityNumber) {
                            html += `<span class='prop'>MMSI ${HtmlHelper.syntaxHighlight(filter, item.maritimeMobileServiceIdentityNumber)}</span>`;
                        }
        
                        if (item.deadweightTonnage) {
                            html += `<span class='prop'>DWT ${NumberHelper.getFormattedValue(item.deadweightTonnage, null, 0, 0)}</span>`;
                        }
                        if (item.vesselTypeValue) {
                            html += `<span class='prop'>${item.vesselTypeValue}</span>`;
                        }
        
                        html += "</div>";
        
                        html += isAuthenticated ? "</a>" : "</div>";
        
                        return html;
                    }
                },
                claims: [],
                columnOverrides: [
                    {
                        getCellInlineStyles: null,
                        getComponentClass: null,
                        property: 'dateOfBuild',
                        valueConverter: (value) => {
                            return value ? (Math.floor(moment().diff(value, 'year', true) * 10) / 10).toFixed(1) + "y/o" + " (" + moment(value).year() + ")" : null;
                        }
                    },
                    {
                        property: 'safetyRating',
                        valueConverter: (value) => {
                            return value && value > 0 ? value : " ";
                        }
                    }
                ]
            },
            {
                title: "Companies",
                uri: "CompanySearch",
                key: 'InformativeCompanySearch',
                entityType: EntityTypes.Company,
                typeSingular: "Company",
                editRoute: "company",
                isVisible: true,
                properties: "fullName,owCode",
                format: (filter, item) => {
        
                    const trackingGuid = GuidHelper.generateGuid();
                    let html = "<a class='column' href='" + this.baseUrl + "/company/" + item.id + "?entity-search="+trackingGuid+"'><div class='row nowrap'>";
                    html += "<svg class='icon-arrow' version='1.1' viewBox='0 0 14 14'>" +
                        "<path d='M13,0h0.2h0.1l0,0h0.1h0.1h0.1l0,0l0.2,0.2l0.1,0.1l-0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2l0,0c0,0,0,0.1,0,0.1l0,0" +
                        "v0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1l0,0c0.1,0,0.2,0.1,0.2,0.2l0,0c0,0.1,0,0.1,0,0.2v9c0,0.6-0.4,1-1,1s-1-0.4-1-1l0,0V3.4L1.7,13.7" +
                        "c-0.4,0.4-0.9,0.4-1.3,0.1l-0.1-0.1c-0.4-0.4-0.4-1,0-1.4c0,0,0,0,0,0l0,0L10.6,2H4C3.5,2,3.1,1.6,3,1.1V1c0-0.6,0.4-1,1-1H13z'/>" +
                        "</svg>";
                    html += `<span class='name'>${HtmlHelper.syntaxHighlight(filter, item.shortCompanyName)}</span></div>`;
                    html += "<div class='prop-container row'>"
                    if (item.countryName)
                        html += `<span class='prop'>${item.countryName}</span>`;
                    html += `<span class='prop'>${item.vesselsUnderManagementWithAllRoles ?? 0} vessels In Service`;
        
                    if (item.vesselsUnderManagement && item.vesselsUnderManagement > 0) {
                        html += ` (${item.vesselsUnderManagement} as DOC)</span>`;
                    } else {
                        html += `</span>`;
                    }
        
                    html += "</div></a>";
                    return html;
                },
                claims: [],
                columnOverrides: [
                    {
                        property: "country",
                        titleToolTip: "Country of domicile, physical location of the company."
                    },
                    {
                        property: "registrationCountry",
                        titleToolTip: "Country where the company is legally registered as an entity."
                    },
                    {
                        property: "controlCountry",
                        titleToolTip: "Actual nationality of company regardless of physical location."
                    },
                    {
                        property: "docCount",
                        titleToolTip: "Vessels that this company holds a DOC role."
                    }
                ]
            },
            {
                title: "Ports",
                uri: "Ports",
                key: 'Ports',
                typeSingular: "Port",
                format: "{0}, {1}",
                properties: "name,countryName",
                isVisible: true,
                claims: [],
                idPropertyName: "portId"
            },
            {
                title: "Companies",
                uri: "CompanySearch",
                key: 'BasicCompanySearch',
                entityType: EntityTypes.Company,
                typeSingular: "Company",
                editRoute: 'company',
                isVisible: true,
                properties: "fullName,owCode",
                format: (filter, item) => {
                    return item.shortCompanyName;
                },
                claims: [],
                columnOverrides: [
                    {
                        property: "country",
                        titleToolTip: "Country of domicile, physical location of the company."
                    },
                    {
                        property: "registrationCountry",
                        titleToolTip: "Country where the company is legally registered as an entity."
                    },
                    {
                        property: "controlCountry",
                        titleToolTip: "Actual nationality of company regardless of physical location."
                    },
                    {
                        property: "docCount",
                        titleToolTip: "Vessels that this company holds a DOC role."
                    }
                ]
            },
            {
                title: "CompanyOrFreelancedInspectors",
                uri: "CompanyOrFreelancedInspectors",
                key: 'CompanyOrFreelancedInspectors',
                entityType: EntityTypes.CompanyOrFreelancedInspector,
                typeSingular: "CompanyOrFreelancedInspector",
                editRoute: "CompanyOrFreelancedInspector",
                isVisible: true,
                properties: "inspectorName,companyName",
                format: (filter, item) => {
        
                    let html = '<p class="text-bold">' + (item.companyName == 'Individual' ? item.inspectorName + ' (INDIVIDUAL)' : item.companyName) +'</p>';
                    html += '<span class="country-text">' + (item.countryName ?? 'Unknown Country') + '</span>';
       
                    return html;
                },
                claims: []
            }
        ]

        return allEntityTypeConfigurationConstants;
    }
}